// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__Yvnk7","cardHeader":"styles_cardHeader__6gI54","card":"styles_card__d4Pa1","revenue":"styles_revenue__XWQd0","payment":"styles_payment__Jm0XJ"};